function TimeUnit(params) {
  var type = params.type || 0;
  this.classType = 'timeunit-' + type;
}

module.exports = TimeUnit;
